import { render, staticRenderFns } from "./CustomQuillEditor.vue?vue&type=template&id=3af2704f"
import script from "./CustomQuillEditor.vue?vue&type=script&lang=js"
export * from "./CustomQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomQuillEditor.vue?vue&type=style&index=0&id=3af2704f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports